<!--
 * @Description: input 去掉前后空格、状态有 【，】
 disabled:可编辑，不可编辑
 view:true,false =>true:详情 false:不受控制
-->
<template>
  <div class="cos-form-item-detail cos-form-item-input-detail">
    <p :title="valuePage">{{ valuePage }}</p>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps<{
  value?: string | number | string[] | number[]
  cosDes?: string | number
}>()

const valuePage = computed(() => {
  let txt = props.value == null || props.value === '' ? '--' : props.value.toString()
  if (props.cosDes || props.cosDes === 0) {
    txt += ` - ${props.cosDes}`
  }
  return txt
})
</script>
<script lang="ts">
export default { name: 'CosInputView' }
</script>
